import React, { useMemo } from "react";
import { logger } from "@rpldy/shared";
import UploadyContext, { createContextApi } from "./UploadyContext";
import useUploader from "./hooks/useUploader";
const NoDomUploady = props => {
  const {
    listeners,
    debug,
    children,
    inputRef,
    ...uploadOptions
  } = props;
  logger.setDebug(!!debug);
  logger.debugLog("@@@@@@ Uploady Rendering @@@@@@", props);
  const uploader = useUploader(uploadOptions, listeners);
  const api = useMemo(() => createContextApi(uploader, inputRef), [uploader, inputRef]);
  return /*#__PURE__*/React.createElement(UploadyContext.Provider, {
    value: api
  }, children);
};
export default NoDomUploady;